import { createAction } from "@reduxjs/toolkit";

export const clearCache = createAction("system/clearCache");
